// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ConnectionStatusMessage, ConnectionStatusMessageT, verifyConnectionStatusMessage } from './connection-status-message';
import { EarthquakeProtectionMessage, EarthquakeProtectionMessageT, verifyEarthquakeProtectionMessage } from './earthquake-protection-message';
import { EarthquakeStatusMessage, EarthquakeStatusMessageT, verifyEarthquakeStatusMessage } from './earthquake-status-message';
import { EscalatorStatusContent, unionToEscalatorStatusContent, unionListToEscalatorStatusContent } from './escalator-status-content';
import { GeneralStatusMessage, GeneralStatusMessageT, verifyGeneralStatusMessage } from './general-status-message';
import { LoadWeigherStatusMessage, LoadWeigherStatusMessageT, verifyLoadWeigherStatusMessage } from './load-weigher-status-message';
import { ModeStatusMessage, ModeStatusMessageT, verifyModeStatusMessage } from './mode-status-message';
import { TrafficStatusMessage, TrafficStatusMessageT, verifyTrafficStatusMessage } from './traffic-status-message';


export class EscalatorStatusMessage implements flatbuffers.IUnpackableObject<EscalatorStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EscalatorStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEscalatorStatusMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorStatusMessage):EscalatorStatusMessage {
  return (obj || new EscalatorStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEscalatorStatusMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorStatusMessage):EscalatorStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EscalatorStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

statusType():EscalatorStatusContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : EscalatorStatusContent.NONE;
}

status<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startEscalatorStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addStatusType(builder:flatbuffers.Builder, statusType:EscalatorStatusContent) {
  builder.addFieldInt8(0, statusType, EscalatorStatusContent.NONE);
}

static addStatus(builder:flatbuffers.Builder, statusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, statusOffset, 0);
}

static endEscalatorStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // status
  return offset;
}

static createEscalatorStatusMessage(builder:flatbuffers.Builder, statusType:EscalatorStatusContent, statusOffset:flatbuffers.Offset):flatbuffers.Offset {
  EscalatorStatusMessage.startEscalatorStatusMessage(builder);
  EscalatorStatusMessage.addStatusType(builder, statusType);
  EscalatorStatusMessage.addStatus(builder, statusOffset);
  return EscalatorStatusMessage.endEscalatorStatusMessage(builder);
}

unpack(): EscalatorStatusMessageT {
  return new EscalatorStatusMessageT(
    this.statusType(),
    (() => {
      const temp = unionToEscalatorStatusContent(this.statusType(), this.status.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: EscalatorStatusMessageT): void {
  _o.statusType = this.statusType();
  _o.status = (() => {
      const temp = unionToEscalatorStatusContent(this.statusType(), this.status.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}



unpackFields(...fields: string[]): EscalatorStatusMessageT {
  const t = new EscalatorStatusMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('status_type')) {
    t.statusType = this.statusType();
  }
  if (fieldSet.has('status')) {
    t.status = (() => {
      const temp = unionToEscalatorStatusContent(this.statusType(), this.status.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
  }
  return t;
}
}

export class EscalatorStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public statusType: EscalatorStatusContent = EscalatorStatusContent.NONE,
  public status: ConnectionStatusMessageT|EarthquakeProtectionMessageT|EarthquakeStatusMessageT|GeneralStatusMessageT|LoadWeigherStatusMessageT|ModeStatusMessageT|TrafficStatusMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  if (this.status === null || this.status === undefined) {
    throw new Error('Required field "status" is not set');
  }
  const status = builder.createObjectOffset(this.status);

  return EscalatorStatusMessage.createEscalatorStatusMessage(builder,
    this.statusType,
    status
  );
}

clone(): EscalatorStatusMessageT {
  const obj = new EscalatorStatusMessageT();
  obj.statusType = this.statusType;
  obj.status = this.status !== null && typeof (this.status as any).clone === 'function' ? (this.status as any).clone() : this.status;
  return obj;
}

equals(other: EscalatorStatusMessageT): boolean {
  if (this.statusType !== other.statusType) return false;
  if (this.status !== null && other.status !== null) {
    if (typeof (this.status as any).equals === 'function') {
      if (!(this.status as any).equals(other.status)) return false;
    } else if (this.status !== other.status) return false;
  } else if (this.status !== other.status) return false;
  return true;
}
}

export function verifyEscalatorStatusMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, 'status');
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // EarthquakeProtectionMessage
            { const o = verifier.readInt32(pos); verifyEarthquakeProtectionMessage(verifier, pos + o); }
            break;
          case 2: // EarthquakeStatusMessage
            { const o = verifier.readInt32(pos); verifyEarthquakeStatusMessage(verifier, pos + o); }
            break;
          case 3: // GeneralStatusMessage
            { const o = verifier.readInt32(pos); verifyGeneralStatusMessage(verifier, pos + o); }
            break;
          case 4: // ConnectionStatusMessage
            { const o = verifier.readInt32(pos); verifyConnectionStatusMessage(verifier, pos + o); }
            break;
          case 5: // ModeStatusMessage
            { const o = verifier.readInt32(pos); verifyModeStatusMessage(verifier, pos + o); }
            break;
          case 6: // TrafficStatusMessage
            { const o = verifier.readInt32(pos); verifyTrafficStatusMessage(verifier, pos + o); }
            break;
          case 7: // LoadWeigherStatusMessage
            { const o = verifier.readInt32(pos); verifyLoadWeigherStatusMessage(verifier, pos + o); }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, 'status');
  } finally {
    verifier.popDepth();
  }
}
